<template>
  <div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <form class="row pad-to-15">
      <div class="col-md-12 " v-if="errors.has('error')">
        <div class="alert alert-danger">{{getError('error')}}
        </div>
      </div>
      <div class="col-md-12 " v-if="errors.items.length">
        <div class="alert alert-danger alert-custom-danger">{{$t('catalogProd.errorOptions')}}
        </div>
      </div>
      <div class="col-lg-6">
      <div class="card ">
        <div class="card-content">
              <div class="row">
                <div class="col-md-12">
                  <h6>{{$t('catalogProd.generalDetails')}}</h6>
                  <hr class="sm">
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{$t('catalogProd.name')}}</label>
                    <input type="text"
                           name="name"
                           :placeholder="$t('catalogProd.name')"
                           v-validate="modelValidations.name"
                           v-model="model.name"
                           class="form-control">
                    <small class="text-danger" v-if="errors.has('name')">
                      {{ getError('name') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{$t('catalogProd.desc')}}</label>
                    <textarea class="form-control" name="description" v-model="model.description" rows="5"></textarea>
                    <small class="text-danger" v-show="description.invalid">
                      {{ getError('description') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-12 ">
                 <!--  <h6>Images</h6>
                  <hr class="sm"> -->
                  <div class="form-group">
                    <label>{{$t('catalogProd.image')}}</label>
                      <el-upload
                        action=""
                        ref="upload"
                        :limit="2"
                        :file-list="model.imagelist"
                        list-type="picture-card"
                        accept=" .jpg, .jpeg, .png"
                        :on-change="handleImgChnage"
                        :on-exceed="handleExceed"
                        :on-remove="handleRemove"
                        :auto-upload="false">
                        <i class="el-icon-plus"></i>
                        <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                      </el-upload>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('catalogProd.category')}}</label>
                    <select name="category_id"
                                  class="form-control"
                                  data-vv-as="category"
                                  ref="category_id"
                                  v-model="model.category_id"
                                  v-validate="modelValidations.category_id">
                      <!-- <option value="">None</option> -->
                      <option v-for="option in mainCategories"
                                 :value="option.id"
                                 :label="option.name"
                                 :key="option.id">
                      </option>
                    </select>
                    <small class="text-danger" v-show="category_id.invalid">
                      {{ getError('category_id') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('catalogProd.price')}} ({{currency}})</label>
                    <input type="number"
                            min="0"
                           name="price"
                           :placeholder="$t('catalogProd.price')"
                           v-validate="modelValidations.price"
                           v-model="model.price"
                           class="form-control">
                    <small class="text-danger" v-show="price.invalid">
                      {{ getError('price') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-md-12">{{$t('catalogProd.taxes')}}</label>
                    <div class="col-md-12">
                      <v-select v-model="model.taxes"
                                  multiple
                                  :options="taxes"
                                  label="name">
                      </v-select></div>
                      <small class="text-danger" v-if="errors.has('taxes')">
                        {{ getError('taxes') }}
                      </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('catalogProd.status')}}</label>
                    <select name="active"
                            v-model="model.active"
                            class="form-control">
                      <option value="1">{{$t('general.active')}}</option>
                      <option value="0">{{$t('general.inactive')}}</option>
                    </select>
                    <small class="text-danger" v-if="errors.has('status')">
                      {{ getError('status') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('catalogProd.posid')}}</label>
                    <input type="text"
                           name="pos_id"
                           :placeholder="$t('catalogProd.posid')"
                           v-model="model.pos_id"
                           class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('catalogProd.allowUserComments')}}</label>
                    <div class="pad-to-10">
                      <p-switch v-model="model.allow_user_comments" type="success" ></p-switch>
                      <small class="text-danger" v-if="errors.has('allow_user_comments')">
                        {{ getError('allow_user_comments') }}
                      </small>
                    </div>
                  </div>
                </div>


              <!--
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{$t('catalogProd.validFromTo')}}</label><br/>
                    <el-date-picker type="daterange" v-model="model.fromto"
                                        :name="pickerNames"
                                        :picker-options="pickerOptions1"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <small class="text-danger" v-show="date_from.invalid">
                      {{ getError('date_from') }}
                    </small>
                  </div>
                </div> -->
                <div class="col-md-12">
                <!--   <h6>{{$t('catalogProd.prodType')}}</h6>
                        <hr class="sm">
                  <div class="form-group" >
                    <select name="type"
                            v-model="model.type"
                            class="form-control"
                            :disabled="!isNew()">
                      <option value="single">{{$t('catalogProd.singleType')}}</option>
                      <option value="group">{{$t('catalogProd.groupType')}}</option>
                    </select>
                    <small class="text-danger" v-if="errors.has('type')">
                      {{ getError('type') }}
                    </small>
                  </div> -->
                  <input type="hidden" name="" v-model="model.type" value="single">
                </div>
                <div class="col-md-12 ">
                  <div v-if="model.type == 'group'" >
                    <!-- <div class="col-md-12"> -->
                      <div class="form-group row">
                        <label class="col-md-12">Pick products that should be in the group</label>
                        <div class="col-md-12">
                        <v-select v-model="model.child_products"
                                  multiple
                                  :options="products"
                                  label="name"
                                  value="id">
                        </v-select></div>
                        <small class="text-danger col-md-12" v-if="errors.has('child_products')">
                          {{ getError('child_products') }}
                        </small>
                      </div>
                    <!-- </div> -->
                  </div>
                </div>
                <div class="col-md-12 pad-to-15">
                  <h6>{{$t('catalogProd.rewardPoints')}}</h6>
                  <hr class="sm">
                  <div class="form-group">
                    <label>{{$t('catalogProd.moneySpent')}}</label>
                    <small class="help-block">
                      {{$t('catalogProd.numberOfYouNeedToSpend', { currency: currency })}}
                      <div class="pad-to-5">{{$t('catalogProd.rewardPossibelValue')}}:
                        <ul>
                          <li>{{$t('catalogProdRewardsHints.hint1')}}</li>
                          <li>{{$t('catalogProdRewardsHints.hint2')}}</li>
                          <li>{{$t('catalogProdRewardsHints.hint3')}}</li>
                        </ul>
                      </div>
                    </small>
                    1 {{currency}} = <input type="number"
                           min="0"
                           step="0.1"
                           name="monetary_conversion"
                           v-model="model.monetary_conversion"
                           class="form-control in-inline"> {{$t('catalogProd.points')}}
                  </div>
                </div>
                <!-- </div> -->
              </div>
        </div>
      </div>
      </div>

      <div class="col-lg-6">
      <div class="card">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">

              <div class="prod-tabs" direction="horizontal" type="tabs">

                <h6>{{$t('catalogProdOpt.plural')}}</h6>
                <hr class="sm">

                <!-- <v-tab title="Extra" tabId="first" class="text-left icon-search" >
                  <input type="text" v-model="searchwordExtra" placeholder="Search" class="form-control " @input="searchExtra" />
                  <v-tree ref='treeExtra' :data='treeDataExtra' :multiple='true' :halfcheck='true'/>
                </v-tab> -->

                <div :title="$t('catalogProdOpt.plural')" class="text-left">
                  <div class="row">

                    <div class="col-md-12 pad-to-10 " >
                      <!-- <p v-if="model.product_options.length == 0" class="">No options added yet.</p> -->
                      <el-collapse ref="elColl" v-model="tabIndex" accordion>
                        <template v-for="(option, idxO) in model.product_options">
                          <button class="btn btn-danger pull-left btn-icon mar-15" @click.prevent="deleteOption(idxO)"><i class="ti-trash"></i></button>
                        <!--   <input type="text"
                                  v-model="option.name"
                                  @input="updateName(idxO, option.id, option.name)"
                                  class="option-name form-control"
                                  :placeholder="$t('catalogProdOpt.single')"
                                  :disabled="!option.id"> -->
                          <el-collapse-item :title="getOptData(option, 'name')" :name="idxO">
                            <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{$t('catalogProdOpt.single')}}</label>
                                  <select class="form-control"
                                          v-model="option.id"
                                          @change.lazy="changeOption(idxO, option.id, option)"
                                          placeholder="Pick an option"
                                          v-validate="{required: true}"
                                          >
                                    <option selected disabled>{{$t('catalogProd.pickAnOption')}}</option>
                                    <template v-for="prOption in productOptions">
                                      <option :value="prOption.id"
                                              :disabled="disableOption(idxO, prOption.id, true) && option.id != prOption.id" 
                                      >{{ prOption.name }}</option>
                                    </template>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{$t('general.required')}}</label>
                                  <select class="form-control" v-model="option.required">
                                    <option :value="true">{{$t('general.yes')}}</option>
                                    <option :value="false">{{$t('general.no')}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6" v-if="getOptData(option, 'type') == 'checkbox'">
                                <div class="form-group">
                                  <label>{{$t('catalogProd.minNoSelected')}}</label>
                                  <input type="number" v-validate="{min_value: 0}" class="form-control" v-model="option.min_no" />
                                </div>
                              </div>
                              <div class="col-md-6" v-if="getOptData(option, 'type') == 'checkbox'">
                                <div class="form-group">
                                  <label>{{$t('catalogProd.maxNoSelected')}}</label>
                                  <input type="number" v-validate="{min_value: 0}" class="form-control" v-model="option.max_no" />
                                </div>
                              </div>
                            </div>
                            <table class="table no-margin" v-if="option.id != ''">
                              <thead>
                                <tr>
                                  <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                  <th>{{$t('catalogProd.price')}} ({{currency}})
                                    <!-- <small class="xs">{{$t('catalogProd.leaveEmpty')}}</small> -->
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(value, idx) in option.values">
                                  <input type="hidden" v-model="option.id">
                                  <td>
                                    <template v-if="productOptions[getObjectByElemKeyValue('id', option.id, productOptions)]">
                                      <select class="form-control" v-model="value.id" v-validate="{required: true}">
                                        <template v-for="prOption in productOptions[getObjectByElemKeyValue('id', option.id, productOptions)]['values']">
                                          <option :value="prOption.id"
                                                   :disabled="disableOption(idxO, prOption.id, false) && value.id != prOption.id"
                                          >{{ prOption.label }}</option>
                                        </template>
                                      </select>
                                    </template>
                                  </td>
                                  <td>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <input type="number"
                                                v-validate="{min_value: 0}"
                                                class="form-control"
                                                v-model="value.price">
                                      </div>
                                    </div>
                                  </td>
                                  <td><button class="btn btn-simple btn-icon " @click.prevent="deleteOptionValue(idxO, idx)"><i title="Remove" class="ti-close text-danger"></i></button></td>
                                </tr>

                              </tbody>
                              <!-- <tfoot></tfoot> -->
                            </table>
                            <div class="pull-right" v-if="showAddButton(idxO, option)">
                              <button title="" class="btn btn-simple btn-icon mar-bt-5" @click.prevent="addNewOptionValue(idxO)"><i class="ti-plus"></i>
                                  {{$t('general.add')}} {{$t('catalogProdOpt.single')}} {{$t('catalogProdOpt.value')}}
                              </button>
                            </div>
                          </el-collapse-item>
                        </template>
                      </el-collapse>
                    </div>
                    <div class="col-md-12 pad-to-15 pad-bt-10">
                      <button class="btn btn-info btn-icon "
                              v-if="productOptions.length > model.product_options.length" 
                              @click.prevent="addNewOption()">
                        <i class="ti-plus"></i> {{$t('general.add')}} {{$t('catalogProdOpt.single')}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="prod-tabs" direction="horizontal" type="tabs">
                <h6>{{$t('catalogProd.soldWith')}}</h6>
                <hr class="sm">
                <div title="" tabId="first" class="text-left icon-search" >
                  <input type="text" v-model="searchword" :placeholder="$t('general.search')" class="form-control " @input="search" />
                  <v-tree ref='tree' :data='treeData' :multiple='true' :halfcheck='true'/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="text-right">
        <p class="pad-bt-15">
          <a v-if="isNew()" @click.prevent="handleDelete('cancel')" class="btn btn-purple btn">Cancel</a>
          <a v-else @click.prevent="handleDelete('delete this product')" class="btn btn-purple btn">Delete product</a>
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-purple btn">Save</button>
        </p>
      </div> -->
      </div>
    </form>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import VueTabs from 'vue-nav-tabs'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'
  import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
  import VTree from 'vue-tree-halower'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  Vue.component('v-select', vSelect)
  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(VueTabs)
  Vue.use(VTree)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      PSwitch
    },
    props: {
      mainCategoriesParent: {
        type: Array,
        required: true
      },
      productsParent: {
        type: Array,
        required: true
      },
      productsGroupedParent: {
        required: true
      },
      productOptionsParent: {
        required: true
      },
      taxesParent: {
        type: Array,
        required: true
      },
      callback: {
        required: true
      },
      callbackDelete: {
        required: true
      }
    },
    watch: {
      mainCategoriesParent (value, oldVal) {
        this.mainCategories = value
      },
      productsParent (value, oldVal) {
        this.products = value
      },
      productsGroupedParent (value, oldVal) {
        this.productsGrouped = value
        this.getTrees()
      },
      productOptionsParent (value, oldVal) {
        this.productOptions = value
      },
      taxesParent (value, oldVal) {
        this.taxes = value
      }
    },
    computed: {
      ...mapFields(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])
    },
    data () {
      return {
        type: '',
        pickerOptions1: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        tabIndex: null,
        currentTab: '',
        pickerNames: ['date_from', 'date_to'],
        mainCategories: this.value || this.mainCategoriesParent,
        model: [],
        soldWithProducts: [],
        products: this.value || this.productsParent,
        productsGrouped: this.value || this.productsGroupedParent,
        productOptions: this.value || this.productOptionsParent,
        taxes: this.value || this.taxesParent,
        hasImages: false,
        modelValidations: {
          name: {
            required: true,
            min: 3
          },
          sku: {
            required: true
          },
          price: {
            required: true,
            min_value: 0,
            max_value: 999999.99
          },
          category_id: {
            required: true
          }
        },
        optionTypes: ['checkbox', 'radio'],
        searchword: '',
        searchwordExtra: '',
        treeData: [],
        treeDataExtra: [],
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        loading: true
      }
    },
    created: function () {
      this.getData()

      // this.getTrees()
    },
    mounted () {
      this.mapItems()
    },
    methods: {
      isNew () {
        if (this.$route.params.id && this.$route.params.id !== 'add') {
          this.type = this.$t('general.edit')
          return false
        } else {
          this.type = this.$t('general.add')
          return true
        }
      },
      getData () {
        this.$nextTick(function () {
          this.loading = true
        })
        this.errors['items'] = this.removeErrorByName('error', this.errors['items'])
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        var self = this

        var objProps = ['taxes', 'sold_with_products', 'sold_with_categories', 'extra_products', 'extra_categories', 'product_options']
        // get product data
        if (self.$route.params.id && self.$route.params.id !== 'add') {
          var prodId = self.$route.params.id

          self.apiRequest('/product/' + prodId, 'GET', data, function (response) {
            if (response.status === true) {
              // if (response.data[0].date_validfrom && response.data[0].date_validto) {
              //   response.data[0].fromto = [response.data[0].date_validfrom, response.data[0].date_validto]
              // }
              if (response.data[0].image_url) {
                response.data[0].imagelist = response.data[0].image_url
                self.hasImages = response.data[0].images.length > 0
              } else {
                response.data[0].imagelist = []
              }
              for (var prop in objProps) {
                if (response.data[0][objProps[prop]] === undefined || response.data[0][objProps[prop]] === null) {
                  response.data[0][objProps[prop]] = []
                }
              }
              if (response.data[0].category.id !== undefined) {
                response.data[0].category_id = response.data[0].category.id
              }
              self.model = response.data[0]
              self.getTrees()

              self.$nextTick(function () {
                self.loading = false
              })
            }
          })
        } else {
          this.model = []
          let object = {
            'taxes': [],
            'sold_with_products': [],
            'sold_with_categories': [],
            'extra_products': [],
            'extra_categories': [],
            'product_options': [],
            'active': 1,
            'type': 'single'
          }
          this.model = object

          self.$nextTick(function () {
            self.loading = false
          })
        }
        this.currency = this.getCurrencySymbol(this.currency)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.errors['items'] = this.removeErrorByName('error', this.errors['items'])
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)
          if (isValid) {
            this.saveProduct()
          } else {
            console.info('is not valid', this.errors)
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0])
          } else {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        var self = this
        const isOkSize = file.size / 1024 / 1024 < 5
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      },
      mapItems () {
        for (var i in this.products) {
          let idx = this.getObjectByElemKeyValue('id', parseInt(this.products[i].id), this.model.sold_with_products)
          if (idx) {
            this.soldWithProducts.push(this.products[i])
          }
        }
      },
      getTrees () {
        var soldWith = []
        this.treeData = []

        var currentProdID = null
        if (!this.isNew()) {
          currentProdID = parseInt(this.$route.params.id)
        }

        for (var id in this.productsGrouped) {
          let idSoldCateg = this.getObjectByElemKeyValue('id', parseInt(id), this.model.sold_with_categories)
          if (idSoldCateg) {
            let data = {'id': id, 'title': this.productsGrouped[id].details.name, 'checked': true}
            let children = []
            for (let idx in this.productsGrouped[id].items) {
              if (currentProdID !== this.productsGrouped[id].items[idx].id) {
                children.push({'id': this.productsGrouped[id].items[idx].id, 'title': this.productsGrouped[id].items[idx].name, 'checked': true})
              }
            }
            data['children'] = children
            soldWith.push(data)
          } else {
            // handle children
            let children = []
            let halfcheck = false
            for (let idx in this.productsGrouped[id].items) {
              let chk = false
              let idSoldProd = this.getObjectByElemKeyValue('id', parseInt(this.productsGrouped[id].items[idx].id), this.model.sold_with_products)
              if (idSoldProd) {
                chk = true
                halfcheck = true
              }
              if (currentProdID !== this.productsGrouped[id].items[idx].id) {
                children.push({
                  'id': this.productsGrouped[id].items[idx].id,
                  'title': this.productsGrouped[id].items[idx].name,
                  'checked': chk
                })
              }
            }
            soldWith.push({'id': id, 'title': this.productsGrouped[id].details.name, 'children': children, 'halfcheck': halfcheck})
          }
        }
        this.treeData = soldWith
      },
      addNewOption () {
        // 'type': 'radiobox',
        // 'name': '',
        // 'modified': false,
        let newRow = {
          'id': null,
          'min_no': 0,
          'required': true,
          'values': []
        }

        this.model.product_options.push(newRow)

        this.tabIndex = this.model.product_options.length - 1
      },
      addNewOptionValue (optIdx) {
        let newRow = {
          'id': null,
          'price': 0
        }
        this.model.product_options[optIdx].values.push(newRow)
      },
      showAddButton (optIdx, option) {
        if (option === undefined) {
          return false
        }
        if (option['id'] === undefined) {
          return false
        }
        var existingOptions = option['values'].length
        var allOptions = this.productOptions[this.getObjectByElemKeyValue('id', option['id'], this.productOptions)]
        if (allOptions === undefined) {
          return false
        }
        allOptions = allOptions['values'].length
        return existingOptions < allOptions
      },
      disableOption (optIdx, optId, main) {
        // let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        let thisOptIdx = false
        if (main) {
          if (this.model.product_options !== undefined) {
            thisOptIdx = this.getObjectByElemKeyValue('id', optId, this.model.product_options)
          }
        } else {
          if (this.model.product_options[optIdx] !== undefined) {
            thisOptIdx = this.getObjectByElemKeyValue('id', optId, this.model.product_options[optIdx]['values'])
          }
        }

        if (thisOptIdx !== false) {
          return true
        } else {
          return false
        }
      },
      deleteOption (thisOptIdx) {
        var self = this
        swal({
          text: self.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            self.model.product_options.splice(thisOptIdx, 1)
          }
        })
      },
      deleteOptionValue (thisOptIdx, thisValIdx) {
        this.model.product_options[thisOptIdx].values.splice(thisValIdx, 1)
      },
      updateName (thisOptIdx, optId, optName) {
        let prOptIdx = this.getObjectByElemKeyValue('id', optId, this.productOptions)
        if (this.productOptions[prOptIdx]['name'] === optName) {
          this.model.product_options[thisOptIdx]['modified'] = false
        } else {
          this.model.product_options[thisOptIdx]['modified'] = true
        }
      },
      getOptData (option, what) {
        if (option.id) {
          let prOptIdx = this.getObjectByElemKeyValue('id', option.id, this.productOptions)
          if (prOptIdx) {
            return this.productOptions[prOptIdx][what]
          }
        }
        switch (what) {
          case 'name': return this.$t('catalogProdOpt.new')
          default: return null
        }
      },
      changeOption (thisOptIdx, optId, option) {
        let prOptIdx = this.getObjectByElemKeyValue('id', this.model.product_options[thisOptIdx].id, this.productOptions)
        this.model.product_options[thisOptIdx]['values'] = []
        // this.model.product_options[thisOptIdx]['type'] = this.productOptions[prOptIdx]['type']
        // this.model.product_options[thisOptIdx]['name'] = this.productOptions[prOptIdx]['name']
        this.model.product_options[thisOptIdx]['required'] = true
        // this.model.product_options[thisOptIdx]['modified'] = false
        this.tabIndex = thisOptIdx
      },
      search () {
        this.$refs.tree.searchNodes(this.searchword)
      },
      searchExtra () {
        this.$refs.treeExtra.searchNodes(this.searchwordExtra)
      },
      handleDelete (label) {
        var btnCounter = 3
        var self = this
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ` + label + `?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              self.$router.push('/products')
            } else {
              var id = this.$route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/product/' + id, 'DELETE', data, function (response) {
                if (response.status === true) {
                  swal(
                    '',
                    self.$t('catalogProd.prodDeleted'),
                    'success'
                  )
                  self.callbackDelete()
                  self.$router.push('/products')
                } else {
                  swal(
                    '',
                    self.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      saveProduct () {
        this.$nextTick(function () {
          this.loading = true
        })

        // manage options values prices first
        if (this.model.product_options.length) {
          for (let optIdx in this.model.product_options) {
            if (this.model.product_options[optIdx]['values'].length) {
              for (let optValIdx in this.model.product_options[optIdx]['values']) {
                let valPrc = this.model.product_options[optIdx]['values'][optValIdx]['price']
                if (valPrc === null || valPrc === '') {
                  this.model.product_options[optIdx]['values'][optValIdx]['price'] = 0
                }
              }
            }
          }
        }

        var data = this.copyObject(this.model)
        // let datacopy = this.model
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')

        // if (this.model['fromto'] !== undefined && this.model['fromto'] && this.model['fromto'][0] && this.model['fromto'][1]) {
        //   data.date_validfrom = this.model['fromto'][0]
        //   data.date_validto = this.model['fromto'][1]
        // } else {
        data.date_validfrom = null
        data.date_validto = null
        // }

        var self = this
        if (data.type === 'single') {
          delete data.child_products
        } else {
          data.child_products = JSON.stringify(data.child_products)
        }
        // delete data.fromto
        delete data.other_images

        // sanitaze product oprion object
        if (data.product_options) {
          for (let optIdx in data.product_options) {
            delete data.product_options[optIdx].type
            delete data.product_options[optIdx].name
            delete data.product_options[optIdx].modified
            delete data.product_options[optIdx].show_in_total_price
            if (data.product_options[optIdx]['values']) {
              for (let optValIdx in data.product_options[optIdx]['values']) {
                delete data.product_options[optIdx]['values'][optValIdx].price_details
                delete data.product_options[optIdx]['values'][optValIdx].label
              }
            }
          }
        }

        data.product_options = JSON.stringify(data.product_options)

        var objProps = ['taxes']
        for (var prop in objProps) {
          if (data[objProps[prop]] === undefined || data[objProps[prop]] === null) {
          } else {
            if (data[objProps[prop]] === []) {
              data[objProps[prop]] = JSON.stringify(data[objProps[prop]])
            } else {
              var vals = []
              var objs = data[objProps[prop]]
              for (var ii in objs) {
                vals.push(objs[ii].id)
              }
              data[objProps[prop]] = JSON.stringify(vals)
            }
          }
        }

        let categs = []
        let prods = []
        for (let idx in this.treeData) {
          if (this.treeData[idx]['checked'] !== undefined && this.treeData[idx]['checked'] === true && (this.treeData[idx]['halfcheck'] === false || this.treeData[idx]['halfcheck'] === undefined)) {
            categs.push(this.treeData[idx]['id'])
          } else {
            for (let idxChild in this.treeData[idx]['children']) {
              if (this.treeData[idx]['children'][idxChild] && this.treeData[idx]['children'][idxChild]['checked'] === true) {
                prods.push(this.treeData[idx]['children'][idxChild]['id'])
              }
            }
          }
        }
        data['sold_with_products'] = JSON.stringify(prods)
        data['sold_with_categories'] = JSON.stringify(categs)

        let makeNull = ['monetary_conversion', 'description', 'sku', 'pos_id']
        for (let field of makeNull) {
          if (typeof data[field] !== 'undefined' && (data[field] === '' || typeof data[field] === 'object')) {
            data[field] = null
          }
        }

        if (this.isNew()) {
          delete data.image
          this.apiRequest('/product', 'POST', data, function (response) {
            if (response.status === true) {
              var id = response.data[0].id
              if (data.imagelist && data.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc
                    self.apiRequest('/product/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogProd.prodAdded'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                        self.callbackDelete()
                        self.$router.push('/products/edit/' + id)
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogProd.prodPhotoError'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                swal(
                  {
                    title: '',
                    text: self.$t('catalogProd.prodAdded'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {})
                self.callbackDelete()
                self.$router.push('/products/edit/' + id)
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          })
        } else {
          var id = this.$route.params.id
          delete data.parent_category
          delete data.images
          delete data.image_url
          delete data.created_at
          delete data.created_by
          delete data.updated_at
          delete data.updated_by
          delete data.deleted_at
          delete data.deleted_by
          delete data.company
          delete data.parent_product
          delete data.top_category
          delete data.category
          delete data.price_details
          delete data.extra_categories
          delete data.extra_products
          // check if the've removed the picture
          if (!data.imagelist[0]) {
            data.images = ''
          }
          let nowHasImages = !!data.imagelist[0]
          data.image_was_removed = (self.hasImages && !nowHasImages)
          delete data.imagelist
          this.apiRequest('/product/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              if (self.model.imagelist[0] && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc
                    self.apiRequest('/product/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.callback(id, {'name': self.model.name, 'price': self.model.price, 'active': self.model.active})
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogProd.prodUpdated'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogProd.prodPhotoError'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.callback(id, {'name': self.model.name, 'price': self.model.price, 'active': self.model.active})
                self.$nextTick(function () { self.loading = false })
                swal(
                  {
                    title: '',
                    text: self.$t('catalogProd.prodUpdated'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {})
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          }) // end api response
        }
      }
    }
  }
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
  .alert-custom-danger { color: #FFF!important; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Products/ProductForm.vue